import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { redirect } from 'redux-first-router';
import { ROUTE_COMPANY, ROUTE_COMPANY_WITH_EVENTS } from '@/constants/routes';
import loadable from '@loadable/component';
const Events = loadable(() => import('@/components/Events'), {
  resolveComponent: (components) => components.Events,
});

export function EventsModal() {
  const dispatch = useDispatch();
  const eventId = useSelector<any, string | undefined>((state) => {
    if (state.location.type === ROUTE_COMPANY_WITH_EVENTS) {
      if (typeof state.location.payload?.eventId === 'string') {
        return state.location.payload.eventId;
      }
      if (typeof state.location.query?.id === 'string') {
        return state.location.query.id;
      }
    }
  }, shallowEqual);

  const payload = useSelector<any, any>((state) => {
    return state.location.payload;
  }, shallowEqual);

  const handleClose = () =>
    dispatch(redirect({ type: ROUTE_COMPANY, payload }));

  if (typeof eventId === 'undefined') {
    return null;
  }
  return <Events eventsId={eventId} onClose={handleClose} />;
}
